import React from 'react';
import MonthPicker from 'components/pickers/month-picker';

const BudgetInfoWidget = (props) => (
    <div className="card no-border">
        <div className="container-xs-height full-height">
            <div className="row-xs-height">
                <div className="col-xs-height col-top">
                    <div className="card-header top-left top-right">
                        <div className="card-title">
                            <span className="font-montserrat fs-11 all-caps">
                                Month Info
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row-xs-height">
                <div className="col-xs-height col-top">
                    <div className="p-l-20 p-t-50 p-b-20 p-r-20">
                        <MonthPicker />
                        {/*<span className="small hint-text pull-left">71% of total goal</span>
                        <span className="pull-right small text-primary">$23,000</span>*/}
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default BudgetInfoWidget;


// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-info-widget.js